import React from 'react';
import { Flame, Clock, ShieldCheck, Zap, Star } from 'lucide-react';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { CountdownTimer } from '../ui/CountdownTimer';
import { trackMetaEvent } from '../analytics/pixelClient';
const CHECKOUT_URL = 'https://ultrapack.digital/cart/48625618714849:1';
const tomos = [{
  age: '0-6 meses',
  title: 'El Despertar de la Escucha',
  brief: 'Escucha, contacto visual y primeros sonidos.'
}, {
  age: '6-12 meses',
  title: 'Del Balbuceo a la Intención',
  brief: 'Del balbuceo a las primeras palabras.'
}, {
  age: '12-18 meses',
  title: 'La Explosión de las Palabras',
  brief: 'Ampliá el vocabulario día a día.'
}, {
  age: '18-24 meses',
  title: 'Conectando Ideas',
  brief: 'De palabras sueltas a frases completas.'
}, {
  age: '24-36 meses',
  title: 'Pequeños Narradores',
  brief: 'Conversaciones, preguntas e historias.'
}, {
  age: '0-36 meses',
  title: 'SOS Fuera de Casa',
  brief: '50 actividades anti-pantalla para cualquier salida.'
}];
export function Product() {
  return <section className="py-12 px-5 bg-white" data-id="element-94">
      <div className="text-center mb-8" data-id="element-95">
        <h2 className="text-sm font-bold text-violet-600 uppercase tracking-widest mb-2" data-id="element-96">
          Presentamos el
        </h2>
        <h3 className="text-3xl font-extrabold text-gray-900 mb-3" data-id="element-97">
          Ultrapack Activador del Habla
        </h3>
        <p className="text-gray-600" data-id="element-98">
          6 tomos con +300 actividades, organizados por edad para que siempre
          sepas qué hacer.
        </p>
      </div>

      {/* Brief tomo list */}
      <div className="space-y-2.5 mb-10" data-id="element-99">
        {tomos.map((tomo, index) => <Reveal key={index} delay={Math.min(index * 0.04, 0.2)} data-id="element-100">
            <div className="flex items-center gap-3 bg-violet-50 rounded-xl p-3 border border-violet-100" data-id="element-101">
              <span className="flex-shrink-0 text-[11px] font-bold text-white bg-violet-600 px-2 py-1 rounded-md w-[74px] text-center" data-id="element-102">
                {tomo.age}
              </span>
              <div className="min-w-0" data-id="element-103">
                <p className="font-bold text-gray-900 text-sm leading-tight" data-id="element-104">
                  {tomo.title}
                </p>
                <p className="text-xs text-gray-500 truncate" data-id="element-105">{tomo.brief}</p>
              </div>
            </div>
          </Reveal>)}
      </div>

      {/* Purchase / offer block */}
      <Reveal data-id="element-106">
        <div id="comprar" className="scroll-mt-6 bg-white rounded-3xl shadow-2xl border-2 border-violet-300 overflow-hidden" data-id="element-107">
          <div className="bg-rose-500 text-white text-center py-4 px-4" data-id="element-108">
            <div className="flex items-center justify-center gap-2 font-extrabold text-sm sm:text-base uppercase tracking-wide mb-2" data-id="element-109">
              <Flame className="w-5 h-5 text-amber-200 animate-pulse" data-id="element-110" />
              🎁 Oferta 70% OFF · Solo 20 cupos
            </div>
            <div className="flex items-center justify-center gap-2 text-sm" data-id="element-111">
              <span className="flex items-center gap-1 font-medium text-rose-50" data-id="element-112">
                <Clock className="w-4 h-4" data-id="element-113" /> La oferta termina en
              </span>
              <CountdownTimer minutes={17} className="text-lg" data-id="element-114" />
            </div>
          </div>

          <div className="p-6" data-id="element-115">
            <div className="text-center bg-violet-100 rounded-2xl p-5 mb-6 border border-violet-200" data-id="element-116">
              <p className="text-sm font-bold text-violet-600 uppercase tracking-wider mb-1" data-id="element-117">
                Hoy lo llevás por solo
              </p>
              <p className="text-5xl font-extrabold text-violet-900 leading-none" data-id="element-118">
                $23.990
              </p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-119">
                Valor real <span className="line-through" data-id="element-120">$84.000</span> ·{' '}
                <span className="font-bold text-rose-500" data-id="element-121">70% OFF</span>
              </p>
            </div>

            <Button variant="green" href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackMetaEvent('InitiateCheckout', {
            value: 23990,
            currency: 'ARS',
            content_name: 'Ultrapack Activador del Habla'
          })} data-id="element-122">
              <span className="text-lg" data-id="element-123">
                ✅ QUIERO EL ULTRAPACK ACTIVADOR AHORA
              </span>
            </Button>

            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-gray-500 font-medium mt-4" data-id="element-124">
              <span className="flex items-center gap-1" data-id="element-125">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-126" /> Garantía 7
                días
              </span>
              <span className="flex items-center gap-1" data-id="element-127">
                <Zap className="w-4 h-4 text-amber-500" data-id="element-128" /> Acceso inmediato
              </span>
            </div>

            <p className="flex items-center justify-center gap-1 text-xs text-violet-500 font-semibold mt-3" data-id="element-129">
              <Star className="w-3.5 h-3.5 fill-violet-400 text-violet-400" data-id="element-130" />
              +4.372 descargas
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}